module.exports = __webpack_public_path__ + "img/LATAM_VEGETABLE_OILS.e603c5f2.png";